module.exports = __webpack_public_path__ + "static/img/habilidades psico.4773b389.png";